import React from 'react'
import { TableGroup } from '@therms/atalaya'
// import PropTypes from 'prop-types'

function GroupsTableHeadRow() {
  return (
    <TableGroup.HeadRow canSelect>
      <TableGroup.HeadCell>Name</TableGroup.HeadCell>
      <TableGroup.HeadCell>Description</TableGroup.HeadCell>
    </TableGroup.HeadRow>
  )
}

GroupsTableHeadRow.propTypes = {}

export { GroupsTableHeadRow }
